import { render, staticRenderFns } from "./newmessage.vue?vue&type=template&id=5a743e9a&"
import script from "./newmessage.vue?vue&type=script&lang=js&"
export * from "./newmessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports